module.exports = __webpack_public_path__ + "static/media/parental-consent.417d81ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/guide/parental-consent.svg
// module id = 596
// module chunks = 0